import { render, staticRenderFns } from "./DocumentTypeListAddNew.vue?vue&type=template&id=5e25ce1c&"
import script from "./DocumentTypeListAddNew.vue?vue&type=script&lang=js&"
export * from "./DocumentTypeListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTypeListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports